import { TLocale } from "./TLocale";

type ERROR_MESSAGES_KEYS = 
| 'not-enough-data'
| 'unknown-error' 

| 'empty-email'
| 'wrong-email'
| 'empty-password'
| 'empty-password-confirm'
| 'short-password'
| 'no-match-passwords'
| 'empty-recaptcha'
| 'signin-failed'
| 'signin-wrong-data'
| 'signup-failed'
| 'empty-activation-key'
| 'activation-failed'

;

const ERROR_MESSAGES_ENG: Record<ERROR_MESSAGES_KEYS, string> = {
  'not-enough-data':  'Not enough data',
  'unknown-error':    'Unknown error',

  // Oauth
  'empty-email':            'Please enter email',
  'wrong-email':            'Wrong email format',
  'empty-password':         'Please enter password',
  'empty-password-confirm': 'Please enter confirm password',
  'short-password':         'Your password is too short',
  'no-match-passwords':     'Passwords don\'t match',
  'empty-recaptcha':        'Faild to generate ReCaptcha',
  'empty-activation-key':   'Please enter activation key',
  'activation-failed':      'Faild to activate using an activation key',

  'signin-failed':      'Signing in failed',
  'signin-wrong-data':  'Invalid username or password',

  'signup-failed': 'Failed to signing in',  
};

export function getErrMsg(key: ERROR_MESSAGES_KEYS, locale?: TLocale): string {
  return {
    'eng': ERROR_MESSAGES_ENG
  }[locale ?? 'eng'][key];
}
